const enUS = {
    testing: "testing en",
    // shown before the backend's translations load, so a refused check never reads as a raw key
    "admin.err.turnstile_required": "Please complete the security check to continue",
    "admin.err.turnstile_failed": "The security check didn't go through. Please try again",
    "admin.err.turnstile_check_failed": "The security check couldn't be completed. Please try again shortly",
    "turnstile.unavailable": "We couldn't verify your browser. Please refresh the page and try again",
    testing2: {
        test: "testing nested en",
    },
    errors: {
        message:{
            400: "Bad Request",
            401: "Unauthorized",
            403: "Forbidden",
            404: "Not Found"
        }
    }
}

export default enUS